import Link from "next/link";
import React, { ChangeEvent, useState } from "react";
import { Col, FormGroup, Input, Row, Table, Container } from "reactstrap";
import FormModal from "~/components/FormModal";
import TextField from "~/components/TextField";
import useApi from "~/hooks/use-api";
import Button from "~/components/Button";
import CheckboxField from "~/components/CheckboxField";
import GlobalAuthHeader from "~/components/GlobalAuthHeader";
import { TodoClickToReveal } from "~/components/TodoClickToReveal";
export interface User {
  id: string;
  email: string;
  name: string;
  isSuper: boolean;
}

export default function UsersPage(): JSX.Element {
  return (
    <>
      <GlobalAuthHeader active="users" />
      <Container>
        <UserDetails />
      </Container>
    </>
  );
}

function UserDetails() {
  const [inviteIsOpen, setInviteOpen] = useState(false);
  const [filterUser, setFilterUser] = useState("");

  const { data: users, revalidate } = useApi<User[]>("/api/global-auth-users");

  const handleFilterUser = (event: ChangeEvent<HTMLInputElement>) => {
    setFilterUser(event.target.value.toLocaleLowerCase());
  };
  return (
    <>
      <Row>
        <Col sm={"5"}>
          <FormGroup>
            <Input
              type="search"
              placeholder="Find Users"
              onChange={handleFilterUser}
              autoFocus={true}
            />
          </FormGroup>
        </Col>
        <Col sm={"3"}>
          <Button onClick={() => setInviteOpen(true)} primary>
            Invite User
          </Button>
        </Col>
      </Row>
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Super</th>
          </tr>
        </thead>
        <tbody>
          {/* TODO: currently only filters email. Name might be included (Backend changes required) */}
          {users ? (
            users
              .filter((u) => u.email.toLocaleLowerCase().includes(filterUser))
              .map((u: User, i: number) => {
                return (
                  <tr key={i}>
                    <td>{u.name}</td>
                    <TodoClickToReveal>
                      <td>
                        <Link
                          href={`/global-auth/users/[userId]`}
                          as={`/global-auth/users/${u.id}`}
                        >
                          <a>{u.email}</a>
                        </Link>
                      </td>
                    </TodoClickToReveal>
                    <td>{u.isSuper.toString()}</td>
                  </tr>
                );
              })
          ) : (
            <p>No users found!</p>
          )}
        </tbody>
      </Table>

      <InviteUserModal
        open={inviteIsOpen}
        onSave={() => {
          revalidate();
          setInviteOpen(false);
        }}
        onClose={() => setInviteOpen(false)}
      />
    </>
  );
}

const initInvite = {
  email: "",
  isSuper: false,
};

function InviteUserModal(props: {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
}) {
  return (
    <FormModal
      title="Invite User"
      open={props.open}
      onClose={props.onClose}
      onSave={props.onSave}
      path={`/api/global-auth-users/user-invite`}
      initValues={initInvite}
      new
    >
      <TextField name="email" label="Email" />
      <CheckboxField
        name="isSuper"
        label="Is Super User"
        description="Grant Super User Access"
      />
    </FormModal>
  );
}
